/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  CreateColumnRequest,
  CreateColumnResponse,
  GetColumnListResponse,
  UpdateColumnRequest,
  UpdateColumnResponse,
} from '../models/index'

export interface CreateTableColumnRequest {
  datasetId: string
  tableId: string
  createColumnRequest: CreateColumnRequest
}

export interface DeleteTableColumnRequest {
  datasetId: string
  tableId: string
  columnId: string
  force: boolean
}

export interface GetTableColumnListRequest {
  datasetId: string
  tableId: string
}

export interface UpdateTableColumnRequest {
  datasetId: string
  tableId: string
  columnId: string
  force: boolean
  updateColumnRequest: UpdateColumnRequest
}

/**
 *
 */
export class DatasetTablesColumnsControllerApi extends runtime.BaseAPI {
  'tableId'
  Request
  initOverrides?: RequestInit | runtime.InitOverrideFunction

  /**
   */
  async createTableColumnRaw(
    requestParameters: CreateTableColumnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateColumnResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling createTableColumn().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling createTableColumn().',
      )
    }

    if (requestParameters['createColumnRequest'] == null) {
      throw new runtime.RequiredError(
        'createColumnRequest',
        'Required parameter "createColumnRequest" was null or undefined when calling createTableColumn().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/column`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId']))),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['createColumnRequest'],
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async createTableColumn(
    requestParameters: CreateTableColumnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateColumnResponse> {
    const response = await this.createTableColumnRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async deleteTableColumnRaw(
    requestParameters: DeleteTableColumnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<object>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling deleteTableColumn().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling deleteTableColumn().',
      )
    }

    if (requestParameters['columnId'] == null) {
      throw new runtime.RequiredError(
        'columnId',
        'Required parameter "columnId" was null or undefined when calling deleteTableColumn().',
      )
    }

    if (requestParameters['force'] == null) {
      throw new runtime.RequiredError(
        'force',
        'Required parameter "force" was null or undefined when calling deleteTableColumn().',
      )
    }

    const queryParameters: any = {}

    if (requestParameters['force'] != null) {
      queryParameters['force'] = requestParameters['force']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/column{columnId}`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId'])))
          .replace(`{${'columnId'}}`, encodeURIComponent(String(requestParameters['columnId']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse<any>(response)
  }

  /**
   */
  async deleteTableColumn(
    requestParameters: DeleteTableColumnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<object> {
    const response = await this.deleteTableColumnRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async getTableColumnListRaw(
    requestParameters: GetTableColumnListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetColumnListResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "data,setId" wasnull or undefined when calling getTableColumnList().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling getTableColumnList().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/column`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse<any>(response)
  }

  /**
   */
  async getTableColumnList(
    requestParameters: GetTableColumnListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetColumnListResponse> {
    const response = await this.getTableColumnListRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async updateTableColumnRaw(
    requestParameters: UpdateTableColumnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<UpdateColumnResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling updateTableColumn().',
      )
    }

    if (requestParameters['tableId'] == null) {
      throw new runtime.RequiredError(
        'tableId',
        'Required parameter "tableId" was null or undefined when calling updateTableColumn().',
      )
    }

    if (requestParameters['columnId'] == null) {
      throw new runtime.RequiredError(
        'columnId',
        'Required parameter "columnId" was null or undefined when calling updateTableColumn().',
      )
    }

    if (requestParameters['force'] == null) {
      throw new runtime.RequiredError(
        'force',
        'Required parameter "force" was null or undefined when calling updateTableColumn().',
      )
    }

    if (requestParameters['updateColumnRequest'] == null) {
      throw new runtime.RequiredError(
        'updateColumnRequest',
        'Required parameter "updateColumnRequest" was null or undefined when calling updateTableColumn().',
      )
    }

    const queryParameters: any = {}

    if (requestParameters['force'] != null) {
      queryParameters['force'] = requestParameters['force']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    const response = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/tables/{tableId}/column/{columnId}`
          .replace(`{${'datasetId'}}`, encodeURIComponent(String(requestParameters['datasetId'])))
          .replace(`{${'tableId'}}`, encodeURIComponent(String(requestParameters['tableId'])))
          .replace(`{${'columnId'}}`, encodeURIComponent(String(requestParameters['columnId']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters['updateColumnRequest'],
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async updateTableColumn(
    requestParameters: UpdateTableColumnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<UpdateColumnResponse> {
    const response = await this.updateTableColumnRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
